import { AddinCommand, getNextControlId, setUilessAddinCommand } from 'owa-addins-store';

export default function executeUiless(addinCommand: AddinCommand, hostItemIndex: string) {
    const controlId = getNextControlId();
    setUilessAddinCommand(controlId, addinCommand, hostItemIndex);
}
